import { InvestigationHistoryPanel } from "#src/routes/investigations/history/InvestigationHistoryPanel";
import { Page, type PageProps } from "@validereinc/common-components";
import React from "react";

type InvestigationPageLayoutProps = Omit<
  PageProps,
  | "pageContentLeftSlot"
  | "shouldContentBeFullHeight"
  | "shouldContentBeFullWidth"
  | "shouldContentHaveNoPadding"
> & {
  selectedInvestigationId?: string;
  children: PageProps["children"];
};

/**
 * Shared full-height Stratos page shell with the investigation history panel.
 */
export const InvestigationPageLayout = ({
  selectedInvestigationId,
  children,
  ...pageProps
}: InvestigationPageLayoutProps) => (
  <Page
    {...pageProps}
    shouldContentBeFullHeight
    shouldContentBeFullWidth
    shouldContentHaveNoPadding
    pageContentLeftSlot={
      <InvestigationHistoryPanel
        selectedInvestigationId={selectedInvestigationId}
      />
    }
  >
    {children}
  </Page>
);
